<template>
	<div
		ref="app-side-bar"
		class="AppSideBarV2"
		@mouseover="opeSideBar()"
		@mouseleave="closeSideBar()"
	>
		<div id="overLaySideBar" class="">
			<!-- <div class="pr-6 pt-4 pl-4 text-right">
				<button :class="{ 'text-white': isFixedSideBar }"
					class="text-side-bar-color hover:text-white"
					@click="setFixedSideNavBar"
				>
					<svg
						class="fill-current h-4 w-4"
						viewBox="0 0 20 20"
						xmlns="http://www.w3.org/2000/svg"
					>
						<title>Menu</title>
						<path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
					</svg>
				</button>
			</div> -->
			<!-- <div class="s1 mb-2">
				<div class="s1__logo s1__userLogo">
					<div class="text-white text-base block ml-16">
						{{ companyData.name }}
					</div>
				</div>
			</div> -->
			<div class="s1 mb-2">
				<div class="s1__logo s1__userLogo">
					<div class="s2" style="color: #fff; cursor: text">
						<div class="s2__imgTitle">
							<div v-if="companyData.name == 'Easy Aspataal'" class="bg-white">
								<img
									src="../../../assets/images/logo/Easyaspataal-logo.png"
									style="width: 100%; height: auto; overflow: hidden"
								/>
							</div>
							<div
								v-else-if="companyData.name == 'BK Asia Pacific'"
								class="bg-white"
							>
								<img
									src="../../../assets/images/logo/BK logo--02.jpg"
									style="
										width: 40px;
										height: 40px;
										border-radius: 0;
										margin-right: 0 !important;
									"
								/>
							</div>
							<div
								v-else-if="
									companyData.id == '15e1f09e-acdb-43de-8009-db3e1bb5c1a1'
								"
								class="flex items-center"
							>
								<img
									src="../../../assets/images/logo/sb-my.png"
									style="
										width: 40px;
										height: 40px;
										border-radius: 0;
										margin-right: 0 !important;
									"
								/>
								<span class="pl-2">{{ " " + companyData.name }}</span>
							</div>
							<div
								v-else-if="
									companyData.name == 'Hardcastle Restaurants Pvt. Ltd.' ||
									companyData.name == 'connaught plaza restaurants'
								"
								class="flex items-center"
							>
								<img
									data-v-1ae766b4=""
									src="../../../assets/images/logo/McDonalds-logo.png"
									style="
										width: 40px;
										height: 40px;
										border-radius: 3px;
										margin-right: 0px !important;
										background: white;
										padding: 5px;
									"
								/>
								<span data-v-1ae766b4="" class="pl-2 capitalize">
									{{ companyData.name }}
								</span>
							</div>
							<div
								v-else-if="companyData.name == 'Blue Tokai'"
								class="flex items-center"
							>
								<img
									data-v-1ae766b4=""
									src="../../../assets/images/logo/bt3.png"
									style="
										width: 45px;
										height: 45px;
										/* border-radius: 3px; */
										/* margin-right: 0px !important; */
										/* background: white; */
										/* padding: 5px; */
									"
								/>
								<span data-v-1ae766b4="" class="pl-2 capitalize">
									{{ companyData.name }}
								</span>
							</div>
							<div
								v-else-if="companyData.name == `Domino's India`"
								class="flex items-center"
							>
								<img
									data-v-1ae766b4=""
									src="../../../assets/images/logo/dominos.png"
									style="
										width: 40px;
										height: 40px;
										/* border-radius: 3px; */
										margin-right: 0px !important;
										background: white;
										/* padding: 5px; */
									"
								/>
								<span data-v-1ae766b4="" class="pl-2 capitalize">
									{{ companyData.name }}
								</span>
							</div>
							<div v-else>{{ companyData.name }}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="dropDowns">
				<!-- <div
					class="s2"
					style="margin-bottom: 1.5rem;"
					:class="{ 'text-white': $route.name == 'AccountSetup' }"
					@click="redirectToAccountSetup()"
				>
					<div class="s2__imgTitle">
						<i class="el-icon-menu s2__icon" />
						<span> Account Setup</span>
					</div>
				</div>-->
				<!-- <div class="dropDown">
					<div
						class="s2"
						:class="{ 'text-white': isDashboardDD }"
						@click="showDashboardData()"
					>
						<div class="s2__imgTitle">
							<img src="../../../assets/images/appSideBarV2/dashboard-24px.png" class="s2__icon" alt="">
							<span>Dashboard</span>
						</div>
						<transition name="angleRotate">
							<i
								class="el-icon-arrow-left text-xs"
								:class="[
									isDashboardDD == true
										? 'angleRotate-enter-active'
										: 'angleRotate-leave-active'
								]"
							/>
						</transition>
					</div> -->
				<!-- <transition name="slideDown">
						<div v-if="isDashboardDD" class="s2__dd">
							<span
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'SingleStoreData' }"
								@click="routeToSalesDashboard()"
								>Sales</span
							>
						</div>
					</transition>
				</div> -->
				<!-- <div v-if="email =='ssinha@burgerking.in' || email =='ntiwari@burgerking.in'" class="dropDown">
					<div
						class="s2"
						:class="{ 'text-white': isSalesDD }"
						@click="routeToSalesLocation()"
					>
						<div class="s2__imgTitle">
							<img
								src="../../../assets/images/appSideBarV2/dashboard-24px.png"
								class="s2__icon"
								alt=""
							/>
							<span>Sales</span>
						</div>
						<transition name="angleRotate">
							<i
								class="el-icon-arrow-left text-xs"
								:class="[
									isSalesDD == true
										? 'angleRotate-enter-active'
										: 'angleRotate-leave-active'
								]"
							/>
						</transition>
					</div>
					<transition name="slideDown" v-if="email =='ssinha@burgerking.in' || email =='ntiwari@burgerking.in'">
						<div v-if="isSalesDD" class="s2__dd">
							<span
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'Location' }"
								@click="routeToSalesLocation()"
								>Location</span
							>
							<span
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'Category' }"
								@click="routeToSalesCategory()"
								>Category</span
							>
							<span
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'SalesStoreType' }"
								@click="routeToSalesStoreType()"
								>Store Type</span
							>
						</div>
					</transition>
				</div> -->
				<!-- v-if="user_id != '865552b3-d65b-4bc0-aa36-152f109e91e2' && user_id !='e6f6efcf-fe4c-4ff6-8ae4-a95e141b912a'" -->
				<div
					v-if="
						user_access_level !== 'vendor' &&
						show_option &&
						!isTheobroma &&
						!sbxMalaysia &&
						companyData.name !== 'Easy Aspataal' &&
						!isBKasia &&
						(isBT || showInventoryDashboard || showSidebarOpt)
					"
					class="dropDown"
				>
					<div
						class="s2"
						:class="{ 'text-white': isSalesDD }"
						@click="showSalesDDdata()"
					>
						<div class="s2__imgTitle">
							<img
								src="../../../assets/images/appSideBarV2/dashboard-24px.png"
								class="s2__icon"
								alt=""
							/>
							<span>Dashboard</span>
						</div>
						<transition name="angleRotate">
							<i
								class="el-icon-arrow-left text-xs"
								:class="[
									isSalesDD == true
										? 'angleRotate-enter-active'
										: 'angleRotate-leave-active',
								]"
							/>
						</transition>
					</div>
					<transition name="slideDown">
						<div class="s2__dd">
							<span
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'Location' }"
								@click="routeToSalesLocation()"
								>Location</span
							>
							<span
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'Category' }"
								@click="routeToSalesCategory()"
								>Category</span
							>
							<!-- <span
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'SalesStoreType' }"
								@click="routeToSalesStoreType()"
								>Store Type</span
							> -->
							<span
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'SalesOrderType' }"
								@click="routeToSalesOrderType()"
								>Order Type</span
							>
						</div>
					</transition>
				</div>

				<!-- <div v-if="user_access_level != 'vendor' && !isTheobroma && (email == 'admin@wellnessforever.in' || email == 'bkpoc@nymbleup.com' || email == 'mcd@nymbleup.com' || email == 'demoid@nymbleup.com' || email == 'haldirams@nymbleup.com' || email == 'tpoc@theobroma.in'|| email == 'theobroma@nymbleup.com') && show_option || showInventoryDashboard" class="dropDown">
					<div
						class="s2"
						:class="{ 'text-white': isSalesForecastDD }"
						@click="showSalesForecastDDdata()"
					>
						<div class="s2__imgTitle"> 
							<img
								src="../../../assets/images/appSideBarV2/visibility-24px.png"
								class="s2__icon"
								alt=""
							/>
							<span>Sales Forecast</span>
						</div>
						<transition name="angleRotate">
							<i
								class="el-icon-arrow-left text-xs"
								:class="[
									isSalesForecastDD == true
										? 'angleRotate-enter-active'
										: 'angleRotate-leave-active'
								]"
							/>
						</transition>
					</div>
					<transition name="slideDown">
						<div v-if="isSalesForecastDD" class="s2__dd">
							<span
								:class="{ 'text-white': $route.name == 'forecastLocation' }"
								class="s2__dd--item"
								@click="routeToForecastLocation()"
								>Location</span
							>
							<span
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'forecastCategory' }"
								@click="routeToForecastCategory()"
								>Category</span
							>
							<span
								class="s2__dd--item"
								:class="{
									'text-white': $route.name == 'forecastCentralKitchen'
								}"
								@click="routeToForecastCentralKitchen()"
								>Central Kitchen</span
							>
						</div>
					</transition>
				</div> -->
				<div v-if="checkSalesForecastV2" class="dropDown">
					<div
						class="s2"
						:class="{ 'text-white': isSalesForecastDDV2 }"
						@click="showSalesForecastDDdataV2()"
					>
						<div class="s2__imgTitle">
							<img
								src="../../../assets/images/appSideBarV2/visibility-24px.png"
								class="s2__icon"
								alt=""
							/>
							<span>Sales Forecast</span>
						</div>
						<transition name="angleRotate">
							<i
								class="el-icon-arrow-left text-xs"
								:class="[
									isSalesForecastDDV2 == true
										? 'angleRotate-enter-active'
										: 'angleRotate-leave-active',
								]"
							/>
						</transition>
					</div>
					<transition name="slideDown">
						<div v-if="isSalesForecastDDV2" class="s2__dd">
							<span
								:class="{
									'text-white': $route.name == 'salesForecastV2',
								}"
								class="s2__dd--item"
								@click="navigateTo('salesForecastV2')"
								>Location</span
							>
							<span
								:class="{
									'text-white': $route.name == 'SalesCategoryForecast',
								}"
								class="s2__dd--item"
								@click="routeToForecastCategoryV2()"
								>Category</span
							>
						</div>
					</transition>
				</div>

				<div
					v-if="
						user_access_level != 'vendor' ||
						isTheobroma ||
						isBT ||
						isGoodFlip ||
						isBB
					"
					class="dropDown"
				>
					<div
						v-if="show_option && !easyAsPataal"
						class="s2"
						:class="{ 'text-white': isLabourPalningDD }"
						@click="showLabourPlaningDDdata"
					>
						<div class="s2__imgTitle">
							<!-- <i class="el-icon-star-on s2__icon" /> -->
							<img
								src="../../../assets/images/appSideBarV2/team-svgrepo-com.png"
								class="s2__icon"
								alt=""
							/>
							<span>Workforce Planning</span>
						</div>
						<transition name="angleRotate">
							<i
								class="el-icon-arrow-left text-xs"
								:class="[
									isLabourPalningDD == true
										? 'angleRotate-enter-active'
										: 'angleRotate-leave-active',
								]"
							/>
						</transition>
					</div>

					<div
						v-if="!show_option || easyAsPataal"
						class="s2"
						:class="{ 'text-white': isLabourPalningDD }"
						@click="showTaskPage"
					>
						<div class="s2__imgTitle">
							<!-- <i class="el-icon-star-on s2__icon" /> -->
							<img
								src="../../../assets/images/appSideBarV2/team-svgrepo-com.png"
								class="s2__icon"
								alt=""
							/>
							<span>Workforce Planning</span>
						</div>
						<transition name="angleRotate">
							<i
								class="el-icon-arrow-left text-xs"
								:class="[
									isLabourPalningDD == true
										? 'angleRotate-enter-active'
										: 'angleRotate-leave-active',
								]"
							/>
						</transition>
					</div>
					<transition name="slideDown">
						<div v-if="isLabourPalningDD" class="s2__dd">
							<span
								v-if="show_option && !isTheobroma && !easyAsPataal && !isBB"
								class="s2__dd--item"
								:class="{ 'text-white': isWorkforceDashboard }"
								@click="toWFD"
								>Workforce Dashboard</span
							>
							<span
								v-if="show_option && !isTheobroma && !easyAsPataal && !isBB"
								class="s2__dd--item"
								:class="{ 'text-white': isSchedulePlanner }"
								@click="
									() =>
										$router.push({ name: 'SchedulePlanner' }).catch(() => {})
								"
								>Schedule Planner</span
							>
							<!-- <span
								v-if="email !='ssinha@burgerking.in' && email !='ntiwari@burgerking.in' && !sbxMalaysia"
								class="s2__dd--item"
								:class="{ 'text-white': isTasks }"
								@click="() => $router.push({ name: 'Tasks' }).catch(()=>{})"
								>Tasks</span
							> -->
							<!-- <span
								v-if="
									email != 'ssinha@burgerking.in' &&
									email != 'ntiwari@burgerking.in' &&
									!sbxMalaysia
								"
								class="s2__dd--item"
								:class="{ 'text-white': isTasks }"
								@click="() => $router.push({ name: 'Tasks' }).catch(() => {})"
								>Tasks</span	
							> -->
							<!-- <transition v-if="user_access_level != 'outlet'" name="slideDown">
								<div v-if="isTicketManagement" class="s2__dd">
									<span
										v-if="
											email == 'theobroma@nymbleup.com'
										"
										class="s2__dd--item"
										:class="{ 'text-white': $route.name == 'ChildPages' }"
										@click="() => $router.push({ name: 'ChildPages' }).catch(() => {})"
										>Projects & Tasks</span
									>
								</div>
							</transition> -->
							<!-- v-if="
									(email != 'ssinha@burgerking.in' &&
										email != 'ntiwari@burgerking.in' &&
										email == 'theobroma@nymbleup.com' &&
										!sbxMalaysia) ||
									isBT ||
									isGoodFlip ||
									isBB ||
									isTheobroma
								" -->
							<!-- <span
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'ChildPages' }"
								@click="
									() => $router.push({ name: 'ChildPages' }).catch(() => {})
								"
								>Projects & Tasks</span
							> -->
							<span
								class="s2__dd--item"
								:class="{ 'text-white': isClusterAvailability }"
								@click="() => $router.push({ name: 'Cluster' }).catch(() => {})"
								>Cluster</span
							>
							<span
								v-if="
									(show_option && !isTheobroma && !easyAsPataal && !isBKasia) ||
									isBT ||
									isGoodFlip ||
									email == 'bkpoc@nymbleup.com' ||
									is_SB_MY
								"
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'Timesheet' }"
								@click="
									() => $router.push({ name: 'Timesheet' }).catch(() => {})
								"
								>Timesheets</span
							>
							<!-- <span
								v-if="show_option && !isTheobroma && !easyAsPataal"
								class="s2__dd--item"
								:class="{ 'text-white': isStoreSettings }"
								@click="() => $router.push({ name: 'StoreDetails' })"
								>Store Settings</span
							> -->
							<span
								v-if="show_option && !isTheobroma && !easyAsPataal"
								class="s2__dd--item"
								:class="{ 'text-white': isStoreSettings }"
								@click="() => $router.push({ name: 'Store' }).catch(() => {})"
								>Store Settings</span
							>
							<!-- <span
								v-if="show_option && !isTheobroma && !easyAsPataal && !isBKasia"
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'Report' }"
								@click="() => $router.push({ name: 'Report' }).catch(() => {})"
								>Report</span
							> -->
							<!-- <span
								v-if="show_option && !isTheobroma && !sbxMalaysia"
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'StoreType' }"
								@click="() => $router.push({ name: 'StoreType' })"
								>Store Type</span
							> -->
							<span
								v-if="
									show_option &&
									!isTheobroma &&
									!sbxMalaysia &&
									!easyAsPataal &&
									!isBKasia
								"
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'Performance' }"
								@click="
									() => $router.push({ name: 'Performance' }).catch(() => {})
								"
							>
								Performance
							</span>
							<!-- <span
								v-if="
									user_id != 'b3d2a694-0c28-446b-abd2-84092c105162' &&
										user_id != '3154a8aa-cb24-4ed5-ab45-77ea5cf7bdb1'
								"
								class="s2__dd--item"
								:class="{
									'text-white':
										$route.name == '/upload-article-master' ||
										$route.name == '/admin/sales-dd/edit-item-master' ||
										$route.name == '/admin/sales-dd/add-item-master' ||
										$route.path == '/nymble-dashboard/item-master/'
								}"
								@click="
									() => $router.push({ path: `/nymble-dashboard/item-master/` })
								"
								>Item Master</span -->
						</div>
					</transition>
				</div>
				<!-- isBT?$router.push({ name: 'NewDashboard' }):$router.push({ name: 'ChildPages' }) -->
				<div
					style="margin-bottom: 25px"
					class="s2"
					@click="$router.push({ name: 'ChildPages' })"
					:class="{ 'text-white': $route.name == 'ChildPages' }"
				>
					<div class="s2__imgTitle">
						<img
							src="../../../assets/images/appSideBarV2/Tasks.svg"
							class="s2__icon"
							alt=""
							style="filter: invert(15%)"
						/>
						<span>Projects & Tasks</span>
					</div>
				</div>
				<div
					style="margin-bottom: 25px"
					class="s2"
					@click="showLicenseManagement"
					:class="{ 'text-white': $route.name == 'license-management' }"
				>
					<div class="s2__imgTitle">
						<img
							src="../../../assets/images/appSideBarV2/business.png"
							class="s2__icon"
							alt=""
							style="filter: invert(15%)"
						/>
						<span>License Management</span>
					</div>
				</div>

				<!-- New Production setup -->
				<div v-if="false" class="dropDown">
					<div
						class="s2"
						:class="{ 'text-white': isProduction }"
						@click="showProductionPage()"
					>
						<div class="s2__imgTitle">
							<img
								src="../../../assets/images/appSideBarV2/production_1.png"
								class="s2__icon"
								alt=""
								style="filter: invert(15%)"
							/>
							<span>Production</span>
						</div>
						<transition name="angleRotate">
							<i
								class="el-icon-arrow-left text-xs"
								:class="[
									isProduction == true
										? 'angleRotate-enter-active'
										: 'angleRotate-leave-active',
								]"
							/>
						</transition>
					</div>
					<transition name="slideDown">
						<div v-if="isProduction" class="s2__dd">
							<span
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'ProductionThawChart' }"
								>Thaw Chart</span
							>
						</div>
					</transition>
				</div>
				<!-- @click="
									() => $router.push({ name: 'ProductionThawChart' }).catch(() => {})
								" -->
				<!-- New Production Setup -->

				<div
					v-if="
						((email == 'admin@wellnessforever.in' ||
							(email == 'bkpoc@nymbleup.com' &&
								user_access_level != 'vendor') ||
							email == 'demoid@nymbleup.com' ||
							email == 'haldirams@nymbleup.com' ||
							email == 'tpoc@theobroma.in' ||
							email == 'theobroma@nymbleup.com') &&
							show_option &&
							!isTheobroma) ||
						showInventoryDashboard
					"
					class="dropDown"
				>
					<div
						class="s2"
						:class="{ 'text-white': isCampaign }"
						@click="showCampaign()"
					>
						<div class="s2__imgTitle">
							<img
								src="../../../assets/images/appSideBarV2/shout.svg"
								class="s2__icon"
								alt=""
								style="filter: invert(80%)"
							/>
							<span>Campaign</span>
						</div>
						<transition name="angleRotate">
							<i
								class="el-icon-arrow-left text-xs"
								:class="[
									isCampaign == true
										? 'angleRotate-enter-active'
										: 'angleRotate-leave-active',
								]"
							/>
						</transition>
					</div>
					<transition name="slideDown">
						<div v-if="isCampaign" class="s2__dd">
							<span
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'CreateCampaign' }"
								@click="
									() => $router.push({ name: 'CreateCampaign' }).catch(() => {})
								"
								>Create Campaign</span
							>
							<span class="s2__dd--item">Campaign Analysis</span>
						</div>
					</transition>
				</div>

				<div
					v-if="
						((email == 'admin@wellnessforever.in' ||
							email == 'bkpoc@nymbleup.com' ||
							email == 'demoid@nymbleup.com' ||
							email == 'haldirams@nymbleup.com' ||
							email == 'tpoc@theobroma.in' ||
							email == 'theobroma@nymbleup.com' ||
							showInventoryDashboard) &&
							show_option &&
							!isTheobroma &&
							!easyAsPataal) ||
						showSidebarOpt
					"
					class="dropDown"
				>
					<div
						class="s2"
						:class="{ 'text-white': isInventoryDD }"
						@click="showInventoryDDdata"
					>
						<div class="s2__imgTitle">
							<!-- <i class="el-icon-star-on s2__icon" /> -->
							<img
								src="../../../assets/images/appSideBarV2/trolley-svgrepo-com.png"
								class="s2__icon"
								alt=""
							/>
							<span>Inventory</span>
						</div>
						<transition name="angleRotate">
							<i
								class="el-icon-arrow-left text-xs"
								:class="[
									isInventoryDD == true
										? 'angleRotate-enter-active'
										: 'angleRotate-leave-active',
								]"
							/>
						</transition>
					</div>
					<transition name="slideDown">
						<div v-if="isInventoryDD" class="s2__dd">
							<span
								v-if="showInventoryDashboard"
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'InventoryDashboard' }"
								@click="() => $router.push({ name: 'InventoryDashboard' })"
								>Inventory Dashboard</span
							>
							<span
								v-if="user_access_level != 'vendor' && !isBT"
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'StockCalendar' }"
								@click="
									() => $router.push({ name: 'StockCalendar' }).catch(() => {})
								"
								>Stock Calendar</span
							>
							<span
								v-if="user_access_level != 'vendor' && !isBT"
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'StockCountStores' }"
								@click="
									() =>
										$router.push({ name: 'StockCountStores' }).catch(() => {})
								"
								>Stock Count</span
							>
							<span
								v-if="user_access_level != 'vendor' && !isBT"
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'WastageCount' }"
								@click="
									() => $router.push({ name: 'WastageCount' }).catch(() => {})
								"
								>Wastage Count</span
							>
							<!-- <span
								v-if="user_access_level != 'vendor'"
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'NewOrder' }"
								@click="redirectToInventoryNewOrder()"
							>
								Orders
							</span> -->
							<span
								v-if="user_access_level != 'vendor'"
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'Orders' }"
								@click="$router.push({ name: 'Orders' })"
							>
								Orders
							</span>
							<span
								class="s2__dd--item"
								:class="{ 'text-white': $route.name == 'SentOrder' }"
								@click="
									() => $router.push({ name: 'SentOrder' }).catch(() => {})
								"
								>Sent Order</span
							>
							<span
								v-if="user_access_level != 'vendor'"
								class="s2__dd--item"
								:class="{
									'text-white':
										$route.name == 'InternalSupplier' ||
										$route.name == 'ExternalSupplier' ||
										$route.name == 'EditProduct' ||
										$route.path == '/nymble-dashboard/supplier/',
								}"
								@click="
									() =>
										$router
											.push({ path: `/nymble-dashboard/supplier/` })
											.catch(() => {})
								"
								>Supplier</span
							>
							<span
								v-if="user_access_level != 'vendor'"
								class="s2__dd--item"
								:class="{
									'text-white':
										$route.name == 'CreateRecipe' ||
										$route.name == 'EditRecipe' ||
										$route.path == '/nymble-dashboard/recipe/',
								}"
								@click="
									() =>
										$router
											.push({ path: `/nymble-dashboard/recipe/` })
											.catch(() => {})
								"
								>Recipe</span
							>
							<span
								v-if="user_access_level != 'vendor'"
								class="s2__dd--item"
								:class="{
									'text-white':
										$route.name == '/upload-article-master' ||
										$route.name == '/admin/sales-dd/edit-item-master' ||
										$route.name == '/admin/sales-dd/add-item-master' ||
										$route.path == '/nymble-dashboard/item-master/',
								}"
								@click="
									() =>
										$router
											.push({ path: `/nymble-dashboard/item-master/` })
											.catch(() => {})
								"
								>Item Master</span
							>
						</div>
					</transition>
				</div>

				<div
					v-if="
						(((user_access_level != 'vendor' &&
							email == 'admin@wellnessforever.in') ||
							email == 'bkpoc@nymbleup.com' ||
							email == 'haldirams@nymbleup.com' ||
							email == 'tpoc@theobroma.in' ||
							email == 'demoid@nymbleup.com' ||
							email == 'theobroma@nymbleup.com') &&
							show_option &&
							!isTheobroma &&
							!easyAsPataal) ||
						showInventoryDashboard
					"
					class="dropDown"
				>
					<div
						class="s2"
						:class="{ 'text-white': isExpiryManagementDD }"
						@click="showExpiryDDdata"
					>
						<div class="s2__imgTitle">
							<i class="el-icon-setting s2__icon" style="font-size: 24px" />
							<span>Expiry Management</span>
						</div>
						<transition name="angleRotate">
							<i
								class="el-icon-arrow-left text-xs"
								:class="[
									isExpiryManagementDD == true
										? 'angleRotate-enter-active'
										: 'angleRotate-leave-active',
								]"
							/>
						</transition>
					</div>
					<transition name="slideDown">
						<div v-if="isExpiryManagementDD" class="s2__dd">
							<span
								class="s2__dd--item"
								:class="{ 'text-white': isExpiryAlert }"
								@click="
									() =>
										$router.push({ name: 'ExpiryAlertList' }).catch(() => {})
								"
								>Alert</span
							>
							<!-- <span class="s2__dd--item">Category</span>
							<span class="s2__dd--item">Store Type</span>
							<span class="s2__dd--item">Order Type</span> -->
						</div>
					</transition>
				</div>

				<!--  <div class="dropDown">
					<div
						class="s2"
						:class="{ 'text-white': isVideoPage }"
						@click="() => $router.push({ name: 'VideoPage' })"
					>
						<div class="s2__imgTitle">
							<i class="el-icon-video-camera s2__icon" style="font-size: 24px;" />
							<span>Videos</span>
						</div>
					</div>

				</div> -->
				<!-- 	v-if="
						(((user_access_level != 'vendor' &&
							email == 'admin@wellnessforever.in') ||
							email == 'bkpoc@nymbleup.com' ||
							email == 'haldirams@nymbleup.com' ||
							email == 'tpoc@theobroma.in' ||
							email == 'demoid@nymbleup.com' ||
							isTheobroma ||
							isBT ||
							email == 'theobroma@nymbleup.com') &&
							show_option) ||
						showInventoryDashboard ||
						showSidebarOpt ||
						email == 'admin@nymbleup.com' ||
						email == 'bt@nymbleup.com'
					" -->
				<div class="dropDown">
					<div
						class="s2"
						:class="{ 'text-white': isTicketManagement }"
						@click="showTicketsData"
					>
						<div class="s2__imgTitle">
							<i class="el-icon-s-ticket s2__icon" style="font-size: 24px" />
							<span>Incident Management</span>
						</div>
						<transition name="angleRotate">
							<i
								class="el-icon-arrow-left text-xs"
								:class="[
									isTicketManagement == true
										? 'angleRotate-enter-active'
										: 'angleRotate-leave-active',
								]"
							/>
						</transition>
					</div>
					<transition name="slideDown">
						<div v-if="isTicketManagement" class="s2__dd">
							<span
								class="s2__dd--item"
								:class="{ 'text-white': isTicketManagement && isTicketsPage }"
								@click="() => $router.push({ name: 'Tickets' }).catch(() => {})"
								>Tickets</span
							>
						</div>
					</transition>
					<transition v-if="user_access_level != 'outlet'" name="slideDown">
						<div v-if="isTicketManagement" class="s2__dd">
							<span
								class="s2__dd--item"
								:class="{
									'text-white': isTicketManagement && isTicketsTemplatePage,
								}"
								@click="
									() =>
										$router.push({ name: 'TicketsTemplate' }).catch(() => {})
								"
								>Templates</span
							>
						</div>
					</transition>
					<!-- Only for  theobroma for TEMP-->
				</div>

				<!-- <div class="dropDown">
					<div
						class="s2"
						:class="{ 'text-white': isSettingsPageOpen }"
						@click="showCompanySettingsPage"
					>
						<div class="s2__imgTitle">
							<i class="el-icon-s-tools s2__icon" style="font-size: 24px;" />
							<span>Settings</span>
						</div>
						<transition name="angleRotate">
							<i
								class="el-icon-arrow-left text-xs"
								:class="[
									isSettingsPageOpen == true
										? 'angleRotate-enter-active'
										: 'angleRotate-leave-active'
								]"
							/>
						</transition>
					</div>
					<transition name="slideDown">
						<div v-if="isSettingsPageOpen" class="s2__dd">
							<span
								class="s2__dd--item"
								:class="{ 'text-white': isSettingsPageOpen && isCompanySettings }"
								@click="() => $router.push({ name: 'Company' })"
								>Company Settings</span
							>
							<span
								class="s2__dd--item"
								:class="{ 'text-white': isSettingsPageOpen && isStoreSettingsPage }"
								@click="() => $router.push({ name: 'Store' })"
								>Store Settings</span
							>
						</div>
					</transition>
				</div> -->
			</div>
		</div>

		<div class="set-logo-at-bottom">
			<div class="s1__logo">
				<img src="../../../assets/images/logo/NymbleUp - N.jpg" alt="img" />
				<span class="text-white text-xl"> NymbleUp </span>
			</div>
		</div>
	</div>
</template>
<script>
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
import { EventBus } from "../../../eventBus";
import { mapActions, mapState } from "vuex";
import { some } from "lodash";
import { serverAddr } from "../../../networkConfig";
import api from "../../../services/labourPalnningService";
import moment from "moment";

export default {
	name: "AppSideBarV2",
	components: {
		simplebar,
	},
	data() {
		return {
			isSideBarWidthMin: true,
			isSideBarWidthMax: false,
			isFixedSideBar: false,
			// isSalesDD: true,
			// isSalesForecastDD: false,
			isReplenishmentDD: false,
			// isInventoryDD: false,
			isInventoryStockCountDD: false,
			isExpiryManagementDD: false,
			isSettingsPageOpen: false,
			isVideoPage: false,
			isLabourDD: false,
			user_id: "",
			user_access_level: "",
			hostname: "",
			email: "",
			show_option: true,
			isSalesForecastDDV2: false,
			underWFD: false,
			underProduction: false,
		};
	},
	computed: {
		...mapState("CommonStore", ["companyData"]),
		...mapState(["loginUserDetails"]),
		isWorkforceDashboard: {
			get: function () {
				const route = this.$route.name;
				return route == "WrokForceDashboard";
			},
			set: function (val) {},
		},
		isKFC() {
			let localData = localStorage.getItem("check_company");
			localData = JSON.parse(localData);
			return localData ? localData.is_kfc : "";
		},
		isMCD() {
			let localData = localStorage.getItem("check_company");
			localData = JSON.parse(localData);
			return localData ? localData.is_mcd : "";
		},
		isCPRL() {
			let localData = localStorage.getItem("check_company");
			localData = JSON.parse(localData);
			return localData ? localData.is_mcd_north : "";
		},
		isDEMO() {
			let localData = localStorage.getItem("check_company");
			localData = JSON.parse(localData);
			return localData ? localData.is_demo : "";
		},
		isBT() {
			let localData = localStorage.getItem("check_company");
			localData = JSON.parse(localData);
			return localData ? localData.is_bt : "";
		},
		is_SB_MY() {
			let localData = localStorage.getItem("check_company");
			localData = JSON.parse(localData);
			return localData ? localData.is_sb_malaysia : "";
		},
		isGoodFlip() {
			const company_id = localStorage.getItem("company_id");
			return company_id === "86da239a-b840-4881-821b-f7462f9bc368";
		},
		isBB() {
			let localData = localStorage.getItem("check_company");
			localData = JSON.parse(localData);
			return localData ? localData.is_bb : "";
		},
		isSalesDD: {
			get: function () {
				const route = this.$route.name;
				return (
					route == "SalesDD" ||
					route == "Location" ||
					route == "Category" ||
					route == "SingleStoreData" ||
					route == "SalesStoreType"
				);
			},
			set: function (val) {},
		},
		isCampaign: {
			get: function () {
				const route = this.$route.name;
				return route === "Campaign" || route === "CreateCampaign";
			},
			set: function (val) {},
		},
		isDashboardDD: {
			get: function () {
				const route = this.$route.name;
				return route == "SingleStoreData";
			},
			set: function (val) {},
		},
		isSalesForecastDD: {
			get: function () {
				const route = this.$route.name;
				return (
					route == "SalesForecastDD" ||
					route == "forecastLocation" ||
					route == "forecastCategory" ||
					route == "forecastCentralKitchen"
				);
			},
			set: function (val) {},
		},
		isInventoryDD: {
			get: function () {
				const route = this.$route.name;
				return (
					route == "InventoryDD" ||
					route == "StoreInventory" ||
					route == "InventoryDashboard" ||
					route == "StockCalendar" ||
					route == "NewOrder" ||
					route == "InternalSupplier" ||
					route == "ExternalSupplier" ||
					this.$route.path == "/nymble-dashboard/supplier/" ||
					route == "SentOrder" ||
					route == "Vendors" ||
					route == "StockCountStores" ||
					route == "StockCountDeliveries" ||
					route == "WastageCount" ||
					route == "WarehouseDelivery" ||
					route == "EditRecipe" ||
					route == "CreateRecipe" ||
					this.$route.path == "/nymble-dashboard/recipe/" ||
					route == "EditProduct" ||
					route == "NewOrderHOV2" ||
					this.$route.path == "/nymble-dashboard/item-master/"
					// 	(this.$route.path == "/nymble-dashboard/item-master/" &&
					// 		(this.user_id == "b3d2a694-0c28-446b-abd2-84092c105162" ||
					// 			this.user_id == "3154a8aa-cb24-4ed5-ab45-77ea5cf7bdb1")) ||
					// 	(route == "/upload-article-master" &&
					// 		(this.user_id == "b3d2a694-0c28-446b-abd2-84092c105162" ||
					// 			this.user_id == "3154a8aa-cb24-4ed5-ab45-77ea5cf7bdb1")) ||
					// 	(route == "/admin/sales-dd/edit-item-master" &&
					// 		(this.user_id == "b3d2a694-0c28-446b-abd2-84092c105162" ||
					// 			this.user_id == "3154a8aa-cb24-4ed5-ab45-77ea5cf7bdb1")) ||
					// 	(route == "/admin/sales-dd/add-item-master" &&
					// 		(this.user_id == "b3d2a694-0c28-446b-abd2-84092c105162" ||
					// 			this.user_id == "3154a8aa-cb24-4ed5-ab45-77ea5cf7bdb1"))
				);
			},
			set: function (val) {},
		},
		isProduction() {
			const route = this.$route.name;
			return (
				route == "Production" ||
				this.underProduction ||
				route == "ProductionThawChart"
			);
		},
		isLabourPalningDD() {
			const route = this.$route.name;
			return (
				route == "LabourPlaningDD" ||
				route == "WrokForceDashboard" ||
				route == "Report" ||
				route == "StoreType" ||
				route == "StoreSettings" ||
				route == "Store" ||
				route == "StoreDetails" ||
				route == "SchedulePlanner" ||
				route == "Staff" ||
				route == "Tasks" ||
				route == "WorkArea" ||
				route == "Activities" ||
				route == "WorkspacePlanning" ||
				route == "Target" ||
				route == "SchedulePlanner" ||
				route == "ADTAndIPTDetails" ||
				route == "ActualSummary" ||
				route == "DayWiseScheduler" ||
				this.underWFD
				// (this.$route.path == "/nymble-dashboard/item-master/" &&
				// 	(this.user_id != "b3d2a694-0c28-446b-abd2-84092c105162" &&
				// 		this.user_id != "3154a8aa-cb24-4ed5-ab45-77ea5cf7bdb1")) ||
				// (route == "/upload-article-master" &&
				// 	(this.user_id != "b3d2a694-0c28-446b-abd2-84092c105162" &&
				// 		this.user_id != "3154a8aa-cb24-4ed5-ab45-77ea5cf7bdb1")) ||
				// (route == "/admin/sales-dd/edit-item-master" &&
				// 	(this.user_id != "b3d2a694-0c28-446b-abd2-84092c105162" &&
				// 		this.user_id != "3154a8aa-cb24-4ed5-ab45-77ea5cf7bdb1")) ||
				// (route == "/admin/sales-dd/add-item-master" &&
				// 	(this.user_id != "b3d2a694-0c28-446b-abd2-84092c105162" &&
				// 		this.user_id != "3154a8aa-cb24-4ed5-ab45-77ea5cf7bdb1"))
			);
		},
		isStoreSettings() {
			const route = this.$route.name;
			/* return (
				route == "StoreSettings" ||
				route == "StoreDetails" ||
				route == "Staff" ||
				route == "WorkArea" ||
				route == "Activities" ||
				route == "Target"
			); */
			return route == "Store";
		},
		isSchedulePlanner: {
			get: function () {
				const route = this.$route.name;
				return (
					route == "SchedulePlanner" ||
					route == "ADTAndIPTDetails" ||
					route == "ActualSummary" ||
					route == "DayWiseScheduler"
				);
			},
			set: function (val) {},
		},
		isClusterAvailability: {
			get: function () {
				const route = this.$route.name;
				return route == "Cluster";
			},
			set: function (val) {},
		},
		isTasks: {
			get: function () {
				const route = this.$route.name;
				return route == "Tasks";
			},
			set: function (val) {},
		},
		isExpiryAlert: {
			get: function () {
				const route = this.$route.name;
				return route == "ExpiryAlertList" || route == "ExpiryAlert";
			},
			set: function (val) {},
		},
		isTicketManagement: {
			get: function () {
				const route = this.$route.name;
				return (
					route == "Tickets" ||
					route == "TicketsTemplate" ||
					route == "TicketsDashboard"
				);
			},
			set: function (val) {},
		},
		isChildPages: {
			get: function () {
				const route = this.$route.name;
				return route == "ChildPages";
			},
			set: function (val) {},
		},
		isTicketsPage() {
			const route = this.$route.name;
			return route == "Tickets";
		},
		isTicketsTemplatePage() {
			const route = this.$route.name;
			return route == "TicketsTemplate";
		},
		isTheobroma() {
			console.log(this.email, "tho");
			if (this.email) {
				if (
					this.email.toLowerCase().indexOf("@theobroma.in") !== -1 ||
					this.email.toLowerCase().includes("theobroma")
				) {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		},
		isBKasia() {
			if (this.email) {
				if (this.email && "bkasia@nymbleup.com") {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		},
		sbxMalaysia() {
			if (this.email) {
				if (this.email == "sbdemo@nymbleup.com") {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		},
		easyAsPataal() {
			if (this.companyData.name == "Easy Aspataal") {
				return true;
			} else {
				return false;
			}
		},
		isCompanySettings() {
			const route = this.$route.name;
			if (route == "Company") {
				return true;
			} else {
				return false;
			}
		},
		isStoreSettingsPage() {
			const route = this.$route.name;
			if (route == "Store") {
				return true;
			} else {
				return false;
			}
		},
		showInventoryDashboard() {
			let show = false;
			if (
				(localStorage.getItem("company_id") &&
					localStorage.getItem("company_id") ==
						"f832c1b1-1acf-4602-8ead-00f35138bcc3") ||
				localStorage.getItem("user_email") == "mystarbucks@nymbleup.com"
			) {
				show = true;
			}
			return show;
		},
		showSidebarOpt() {
			let show = false;
			if (this.isBT) {
				show = true;
			}
			return show;
		},
		checkSalesForecastV2() {
			return (
				localStorage.getItem("user_email") === "demoid@nymbleup.com" ||
				localStorage.getItem("user_email") === "inventorydemo@nymbleup.com" ||
				localStorage.getItem("user_email") === "mystarbucks@nymbleup.com" ||
				localStorage.getItem("user_email") === "bigbasket@nymbleup.com" ||
				localStorage.getItem("user_email") === "bt@nymbleup.com" ||
				this.isBT
			);
		},
	},
	watch: {
		$route(to, from) {
			if (to.name == "Store" || to.name == "Company") {
				this.isSettingsPageOpen = true;
			} else {
				this.isSettingsPageOpen = false;
			}
		},
	},
	mounted() {
		this.hostname = location.host;
		// https://starbucksindia.nymbleup.com/
		this.user_id = localStorage.getItem("user_id");
		this.user_access_level = localStorage.getItem("user_access_level");

		if (!Object.keys(this.companyData).length) {
			this.getCompanyData();
		}

		var user_info = "";
		user_info = this.loginUserDetails;
		console.log(user_info, "user_info");
		if (user_info && Object.keys(user_info).length != 0) {
			this.email = user_info.email;
		} else {
			serverAddr
				.get("/users/self/", {})
				.then((res) => {
					this.$store.commit("getUserDetails", JSON.parse(res.data));
					user_info = this.$store.state.loginUserDetails;
					this.email = user_info.email;
				})
				.catch((error) => {
					console.log("error", error);
				});
		}

		window.addEventListener("beforeunload", (event) => {
			// Cancel the event as stated by the standard.
			// event.preventDefault();
			// Chrome requires returnValue to be set.
			window.localStorage.removeItem("errorsInCsv");
			// event.returnValue = "";
		});
		// console.log(this.companyData);
		// console.log(this.$route.name);
		this.email = localStorage.getItem("user_email");
		this.checkUserAuth();
		let route = this.$route.name;
		if (route == "Company" || route == "Store") {
			this.isSettingsPageOpen = true;
		} else {
			this.isSettingsPageOpen = false;
		}
	},
	destroyed() {},
	methods: {
		navigateTo(route) {
			let store = null;
			store = localStorage.getItem("store") || localStorage.getItem("store_id");
			// Get all outlets
			if (!store) {
				api
					.getAllStoreData()
					.then((response) => {
						let outlets = JSON.parse(response.data);
						if (outlets.length > 0) {
							store = outlets[0].id;
							localStorage.setItem("store", store);
							localStorage.setItem("store_id", store);
						}
						EventBus.$emit("hideSetting", false);
						EventBus.$emit("handleForecastRoute", true);
						const week_first_day = moment()
							.startOf("isoWeek")
							.format("YYYY-MM-DD");
						const week_last_day = moment()
							.endOf("isoWeek")
							.format("YYYY-MM-DD");
						this.$router
							.push({
								name: route,
								query: {
									view: "week",
									start_date: week_first_day,
									end_date: week_last_day,
								},
								params: { selectedOutlet: store, selectedWeek: week_first_day },
							})
							.catch(() => {});
					})
					.catch((error) => {
						console.error("Error fetching data:", error);
					});
			} else {
				EventBus.$emit("hideSetting", false);
				EventBus.$emit("handleForecastRoute", true);
				const week_first_day = moment().startOf("isoWeek").format("YYYY-MM-DD");
				const week_last_day = moment().endOf("isoWeek").format("YYYY-MM-DD");
				this.$router
					.push({
						name: route,
						query: {
							view: "week",
							start_date: week_first_day,
							end_date: week_last_day,
						},
						params: { selectedOutlet: store, selectedWeek: week_first_day },
					})
					.catch(() => {});
			}
		},
		checkUserAuth() {
			// admin@wellnessforever.in
			if (
				this.email == "tushar.shinde@wellnessforever.in" ||
				this.email == "gokuldas.gawade@wellnessforever.in" ||
				this.email == "safiahmad.khan@wellnessforever.in" ||
				this.email == "ratnesh.maurya@wellnessforever.in" ||
				this.email == "amar.soni@wellnessforever.in"
			) {
				this.show_option = false;
			} else {
				this.show_option = true;
			}
		},

		...mapActions("CommonStore", ["getCompanyData"]),
		opeSideBar: _.debounce(function () {
			let overLaySideBar = document.getElementById("overLaySideBar");
			let AppSideBarV2 = document.getElementsByClassName("AppSideBarV2");
			// let body = document.getElementsByTagName('body')[0];
			// let fixedSideBar = document.getElementById('fixedSideBar');

			// fixedSideBar.style.display = 'none';
			// body.style.overflow = 'hidden';
			overLaySideBar.style.display = "block";
			AppSideBarV2[0].style.width = "280px";
			AppSideBarV2[0].style.zIndex = "111";

			overLaySideBar.classList.add("overlay-side-nav");
			overLaySideBar.classList.remove("close-side-nav");
		}, 600),

		closeSideBar: _.debounce(function () {
			let overLaySideBar = document.getElementById("overLaySideBar");
			let AppSideBarV2 = document.getElementsByClassName("AppSideBarV2");
			// let body = document.getElementsByTagName('body')[0];
			// let fixedSideBar = document.getElementById('fixedSideBar');

			// overLaySideBar.style.display = 'none';
			// fixedSideBar.style.display = 'block';
			// body.style.overflow = 'auto';
			AppSideBarV2[0].style.width = "60px";

			overLaySideBar.classList.remove("overlay-side-nav");
			overLaySideBar.classList.add("close-side-nav");

			// console.log('mover leave');
		}, 600),

		setFixedSideNavBar() {
			if (!this.isFixedSideBar) {
				this.$refs["app-side-bar"].style.width = "17rem";
				document.getElementById("app").style.marginLeft = "17rem";
				document.getElementById("app").style.transition = "0.5s";
				this.isSideBarWidthMax = true;
				this.isSideBarWidthMin = false;
				this.isFixedSideBar = true;
				EventBus.$emit("updateSideBarPosition", "open");
				return;
			} else if (this.isFixedSideBar) {
				this.$refs["app-side-bar"].style.width = "60px";
				document.getElementById("app").style.marginLeft = "60px";
				document.getElementById("app").style.transition = "0.5s";
				this.isSideBarWidthMin = true;
				this.isSideBarWidthMax = false;
				this.isFixedSideBar = false;
				EventBus.$emit("updateSideBarPosition", "close");
				return;
			}
		},
		mouseOverFn() {
			if (!this.isFixedSideBar && this.isSideBarWidthMin) {
				this.$refs["app-side-bar"].style.width = "17rem";
				document.getElementById("app").style.marginLeft = "17rem";
				document.getElementById("app").style.transition = "0.5s";
				this.isSideBarWidthMax = true;
				return;
			}
		},
		mouseOutFn() {
			if (!this.isFixedSideBar && this.isSideBarWidthMax) {
				this.$refs["app-side-bar"].style.width = "60px";
				document.getElementById("app").style.marginLeft = "60px";
				document.getElementById("app").style.transition = "0.5s";
				this.isSideBarWidthMin = true;
				return;
			}
		},
		showSalesDDdata() {
			EventBus.$emit("hideSetting", false);
			this.isSalesForecastDD = false;
			this.isReplenishmentDD = false;
			this.isInventoryDD = false;
			this.isInventoryStockCountDD = false;
			this.isExpiryManagementDD = false;
			this.isVideoPage = false;
			this.isLabourDD = false;
			var user_id = localStorage.getItem("user_id");
			this.isSalesDD = !this.isSalesDD;

			if (
				this.email == "admin@wellnessforever.in" ||
				this.email == "bkpoc@nymbleup.com" ||
				email == "haldirams@nymbleup.com" ||
				email == "tpoc@theobroma.in" ||
				email == "theobroma@nymbleup.com"
			) {
				this.$router.push("/single-store").catch(() => {});
			} else {
				this.$router.push("/admin/sales-dd/location").catch(() => {});
			}
			// if (
			// 	user_id == "b3d2a694-0c28-446b-abd2-84092c105162" ||
			// 	user_id == "3154a8aa-cb24-4ed5-ab45-77ea5cf7bdb1"
			// ) {
			// this.isSalesDD = !this.isSalesDD;
			// 	//if user name is 'Admin Admin or demoId' then shown inverntory dropdown
			// } else {
			// 	this.$router.push({
			// 		name: "InventoryDisabled",
			// 		params: { type: "sales" }
			// 	});
			// }
		},
		showDashboardData() {
			EventBus.$emit("hideSetting", false);
			this.isSalesDD = false;
			this.isSalesForecastDD = false;
			this.isReplenishmentDD = false;
			this.isInventoryDD = false;
			this.isInventoryStockCountDD = false;
			this.isExpiryManagementDD = false;
			this.isVideoPage = false;
			this.isLabourDD = false;
			var user_id = localStorage.getItem("user_id");
			this.isDashboardDD = !this.isDashboardDD;
			this.$router.push("/single-store").catch(() => {});
			// if (
			// 	user_id == "b3d2a694-0c28-446b-abd2-84092c105162" ||
			// 	user_id == "3154a8aa-cb24-4ed5-ab45-77ea5cf7bdb1"
			// ) {
			// 	//if user name is 'Admin Admin or demoId' then shown inverntory dropdown
			// 	this.$router.push("/single-store");
			// } else {
			// 	this.$router.push({
			// 		name: "InventoryDisabled",
			// 		params: { type: "sales" }
			// 	});
			// }
		},
		showSalesForecastDDdata() {
			EventBus.$emit("hideSetting", false);
			this.isSalesDD = false;
			this.isReplenishmentDD = false;
			this.isInventoryDD = false;
			this.isInventoryStockCountDD = false;
			this.isVideoPage = false;
			this.isExpiryManagementDD = false;
			this.isLabourDD = false;
			this.isSalesForecastDD = !this.isSalesForecastDD;
			var user_id = localStorage.getItem("user_id");
			this.$router.push({ name: "forecastLocation" }).catch(() => {});
			// if (
			// 	user_id == "b3d2a694-0c28-446b-abd2-84092c105162" ||
			// 	user_id == "3154a8aa-cb24-4ed5-ab45-77ea5cf7bdb1"
			// ) {
			// 	//if user name is 'Admin Admin or demoId' then shown inverntory dropdown
			// 	this.$router.push({ name: "forecastLocation" });
			// } else {
			// 	this.$router.push({
			// 		name: "InventoryDisabled",
			// 		params: { type: "sales-forecast" }
			// 	});
			// }
		},
		showSalesForecastDDdataV2() {
			EventBus.$emit("hideSetting", false);
			this.isSalesDD = false;
			this.isReplenishmentDD = false;
			this.isInventoryDD = false;
			this.isInventoryStockCountDD = false;
			this.isVideoPage = false;
			this.isExpiryManagementDD = false;
			this.isLabourDD = false;
			this.isSalesForecastDDV2 = !this.isSalesForecastDDV2;
			var user_id = localStorage.getItem("user_id");
			// this.$router.push({ name: "forecastLocation" }).catch(()=>{});
			// if (
			// 	user_id == "b3d2a694-0c28-446b-abd2-84092c105162" ||
			// 	user_id == "3154a8aa-cb24-4ed5-ab45-77ea5cf7bdb1"
			// ) {
			// 	//if user name is 'Admin Admin or demoId' then shown inverntory dropdown
			// 	this.$router.push({ name: "forecastLocation" });
			// } else {
			// 	this.$router.push({
			// 		name: "InventoryDisabled",
			// 		params: { type: "sales-forecast" }
			// 	});
			// }
		},
		showCampaign() {
			EventBus.$emit("hideSetting", false);
			this.isSalesForecastDD = false;
			this.isSalesDD = false;
			this.isInventoryStockCountDD = false;
			this.isExpiryManagementDD = false;
			this.isVideoPage = false;
			this.isLabourDD = false;
			this.isCampaign = true;
			this.$router.push({ name: "Campaign" }).catch(() => {});
		},
		showInventoryDDdata() {
			EventBus.$emit("hideSetting", false);
			this.isSalesForecastDD = false;
			this.isSalesDD = false;
			this.isInventoryStockCountDD = false;
			this.isExpiryManagementDD = false;
			this.isVideoPage = false;
			this.isLabourDD = false;
			var user_id = localStorage.getItem("user_id");
			if (this.hostname != "starbucksindia.nymbleup.com") {
				this.isInventoryDD = !this.isInventoryDD;
				//if user name is 'Admin Admin or demoId' then shown inverntory dropdown
				this.$router.push({ name: "InventoryDashboard" }).catch(() => {});
			} else {
				this.$router
					.push({
						name: "InventoryDisabled",
						params: { type: "inventory" },
					})
					.catch(() => {});
			}
		},
		showExpiryDDdata() {
			EventBus.$emit("hideSetting", false);
			this.isInventoryDD = false;
			this.isSalesForecastDD = false;
			this.isSalesDD = false;
			this.isInventoryStockCountDD = false;
			this.isLabourDD = false;
			var userId = localStorage.getItem("user_id");
			if (this.hostname != "starbucksindia.nymbleup.com") {
				this.isExpiryManagementDD = !this.isExpiryManagementDD;
				//if user name is 'Admin Admin or demoId' then shown inverntory dropdown
				this.$router.push({ name: "ExpiryDashboard" }).catch(() => {});
				// this.$router.push({ name: "ExpiryAlert" });
			} else {
				this.$router
					.push({
						name: "InventoryDisabled",
						params: { type: "expiry" },
					})
					.catch(() => {});
			}
		},
		showCompanySettingsPage() {
			EventBus.$emit("hideSetting", false);
			this.isInventoryDD = false;
			this.isSalesForecastDD = false;
			this.isSalesDD = false;
			this.isInventoryStockCountDD = false;
			this.isLabourDD = false;
			this.isSettingsPageOpen = !this.isSettingsPageOpen;
		},
		showLabourPlaningDDdata() {
			EventBus.$emit("hideSetting", false);
			this.underWFD = !this.underWFD;
			this.isSalesDD = false;
			// this.$router.push({ name: "WorkspacePlanning" })
			// if(!this.isTheobroma) {
			// 	this.$router.push({ name: "WrokForceDashboard" });
			// } else {
			// 	this.$router.push({ name: "Tasks" });
			// }
		},
		showLicenseManagement() {
			this.$router.push({ name: "license-management" });
		},
		showProductionDDdata() {
			this.underProduction = !this.underProduction;
		},
		toWFD() {
			if (!this.isTheobroma) {
				this.$router.push({ name: "WrokForceDashboard" });
			} else {
				this.$router.push({ name: "Tasks" });
			}
		},
		toPTC() {
			this.isProduction = !this.isProduction;
			this.$router.push({ name: "ProductionThawChart" }).catch(() => {});
		},
		showTaskPage() {
			EventBus.$emit("hideSetting", false);
			this.isLabourPalningDD = !this.isLabourPalningDD;
			this.isSalesDD = false;
			// this.$router.push({ name: "WorkspacePlanning" })
			this.$router.push({ name: "Tasks" }).catch(() => {});
		},
		showProductionPage() {
			this.isProduction = !this.isProduction;
			this.$router.push({ name: "Production" }).catch(() => {});
		},
		routeToSalesLocation() {
			EventBus.$emit("hideSetting", false);
			this.$router.push("/admin/sales-dd/location").catch(() => {});
		},
		routeToSalesDashboard() {
			EventBus.$emit("hideSetting", false);
			this.$router.push("/single-store").catch(() => {});
		},
		routeToSalesCategory() {
			EventBus.$emit("showLoader", true);
			EventBus.$emit("hideSetting", false);
			this.$router.push("/admin/sales-dd/category").catch(() => {});
		},
		routeToSalesStoreType() {
			EventBus.$emit("showLoader", true);
			EventBus.$emit("hideSetting", false);
			this.$router.push("/admin/sales-dd/sales-store-type").catch(() => {});
		},
		routeToSalesOrderType() {
			EventBus.$emit("showLoader", true);
			this.$router.push("/admin/sales-dd/sales-order-type").catch(() => {});
		},
		routeToForecastLocation() {
			EventBus.$emit("hideSetting", false);
			this.$router.push({ name: "forecastLocation" }).catch(() => {});
		},
		routeToForecastLocationV2() {
			EventBus.$emit("hideSetting", false);
			EventBus.$emit("handleForecastRoute", true);
			this.$router.push({ name: "SalesLocationForecast" }).catch(() => {});
		},
		routeToForecastCategoryV2() {
			EventBus.$emit("hideSetting", false);
			EventBus.$emit("handleForecastRoute", true);
			this.$router.push({ name: "SalesCategoryForecast" }).catch(() => {});
		},
		routeToForecastCategory() {
			EventBus.$emit("hideSetting", false);
			this.$router.push({ name: "forecastCategory" }).catch(() => {});
		},
		routeToForecastCentralKitchen() {
			EventBus.$emit("hideSetting", false);
			this.$router.push({ name: "forecastCentralKitchen" }).catch(() => {});
		},
		redirectToAccountSetup() {
			EventBus.$emit("hideSetting", false);
			this.$router.push({ path: "/account-setup" }).catch(() => {});
		},
		redirectToInventory() {
			EventBus.$emit("hideSetting", false);
			this.isInventoryDD = !this.isInventoryDD;
			this.$router
				.push({ path: "/admin/inventory-dd/recipe-build" })
				.catch(() => {});
		},
		redirectToInventoryNewOrder() {
			EventBus.$emit("hideSetting", false);
			this.$router
				.push({ path: "/admin/inventory-dd/planned-indents" })
				.catch(() => {});
		},
		showTicketsData() {
			EventBus.$emit("hideSetting", false);
			this.$router.push({ name: "TicketsDashboard" }).catch(() => {});
		},
	},
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/variable.scss";
@import "./appSideBarV2.scss";
.overlay-side-nav {
	min-height: 100vh;
	width: 280px;
	// position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	// padding: 0 15px;
	transition: all 0.1s ease 0s;
	background: #2e323a;
	// box-shadow: 0 16px 38px -12px rgba(0,0,0,.56), 0 4px 25px 0 rgba(0,0,0,.12), 0 8px 10px -5px rgba(0,0,0,.2);
	z-index: 555;
}
.close-side-nav {
	left: 60px;
	transition: all 0s ease 0s;
}
</style>
<style>
.AppSideBarV2 .simplebar-scrollbar:before {
	background: #fff !important;
}
</style>
